export default "__VITE_PUBLIC_ASSET__49c8430b__"